import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, MapPin, ShoppingBag, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCart } from '../../contexts/CartContext';

const BottomNav = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { getItemCount } = useCart();
  const itemCount = getItemCount();

  const navItems = [
    { path: '/', icon: Home, label: t('nav.home'), testId: 'nav-home' },
    { path: '/map', icon: MapPin, label: t('nav.map'), testId: 'nav-map' },
    { path: '/orders', icon: ShoppingBag, label: t('nav.orders'), testId: 'nav-orders' },
    { path: '/profile', icon: User, label: t('nav.profile'), testId: 'nav-profile' },
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-border backdrop-blur-xl z-50 max-w-md mx-auto"
    >
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={item.testId}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                active ? 'text-primary' : 'text-muted-foreground'
              }`}
            >
              <div className="relative">
                <Icon className="w-6 h-6" strokeWidth={active ? 2.5 : 2} />
                {item.path === '/orders' && itemCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-accent text-accent-foreground text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
                    {itemCount}
                  </span>
                )}
              </div>
              <span className={`text-xs mt-1 ${active ? 'font-semibold' : ''}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
